export default class ListApi {
  baseUrl = "";

  constructor(type) {
    if(!["industries","job-titles","languages", "usa-cities", "benefits"].includes(type)) throw new Error("Invalid type");
    this.baseUrl = "/api/list/" + type;
  }

  index(params = null) {
    return axios.get(this.baseUrl, { params });
  }
}
